/* =============================================
   RHYKIN HOMEPAGE — JAVASCRIPT
   ============================================= */

// ── Scroll-triggered fade-in animations ──────────────────────────────────────
const fadeObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      // Stagger sibling cards
      const siblings = entry.target.parentElement.querySelectorAll('.rh-fade-in');
      siblings.forEach((el, idx) => {
        if (!el.classList.contains('rh-visible')) {
          setTimeout(() => el.classList.add('rh-visible'), idx * 80);
        }
      });
      entry.target.classList.add('rh-visible');
      fadeObserver.unobserve(entry.target);
    }
  });
}, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

document.querySelectorAll('.rh-fade-in').forEach(el => fadeObserver.observe(el));


// ── Stat counter animation ────────────────────────────────────────────────────
let statsAnimated = false;

const statObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting && !statsAnimated) {
      statsAnimated = true;
      animateStats();
      statObserver.disconnect();
    }
  });
}, { threshold: 0.3 });

const statsBanner = document.querySelector('.rh-stats-banner');
if (statsBanner) statObserver.observe(statsBanner);

function animateStats() {
  document.querySelectorAll('.rh-stat-number').forEach(el => {
    const rawTarget = parseInt(el.dataset.target, 10);
    const suffix = el.dataset.suffix || '';
    const isDecimal = el.dataset.decimal === '1';
    const divide = el.dataset.divide ? parseInt(el.dataset.divide, 10) : null;
    const duration = 1600;
    const start = performance.now();

    function tick(now) {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      // Ease out cubic
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = Math.round(eased * rawTarget);

      if (isDecimal && divide) {
        // e.g. rawTarget=48, divide=10 → animates 0.0 → 4.8
        el.textContent = (current / divide).toFixed(1) + suffix;
      } else {
        el.textContent = current + suffix;
      }

      if (progress < 1) {
        requestAnimationFrame(tick);
      } else {
        // Ensure exact final value
        if (isDecimal && divide) {
          el.textContent = (rawTarget / divide).toFixed(1) + suffix;
        } else {
          el.textContent = rawTarget + suffix;
        }
      }
    }

    requestAnimationFrame(tick);
  });
}


// ── Newsletter form ───────────────────────────────────────────────────────────
function handleNewsletterSubmit(e) {
  e.preventDefault();
  const form = e.target;
  const input = form.querySelector('input[type="email"]');
  const btn = form.querySelector('button');

  btn.textContent = '✓ You\'re in!';
  btn.style.background = '#059669';
  btn.style.borderColor = '#059669';
  input.value = '';
  input.placeholder = 'Check your inbox for your 10% off code';
  input.disabled = true;
  btn.disabled = true;
}


// ── Smooth scroll for anchor links ───────────────────────────────────────────
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', (e) => {
    const target = document.querySelector(anchor.getAttribute('href'));
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});
